const KEY = "promptforge_library_v1";

export function getLibrary() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveToLibrary(item) {
  const lib = getLibrary();
  if (lib.find((x) => x.id === item.id)) return lib;
  const next = [item, ...lib].slice(0, 100);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function removeFromLibrary(id) {
  const next = getLibrary().filter((x) => x.id !== id);
  localStorage.setItem(KEY, JSON.stringify(next));
  return next;
}

export function isSaved(id) {
  return getLibrary().some((x) => x.id === id);
}

export function clearLibrary() {
  localStorage.removeItem(KEY);
}
